import { IGif } from "@/common/services/types";
import { nFormatter } from "@/common/utils/parseNumber";
import { memo } from "react";
import { GifStatsItem } from "../GifStatsItem";
import EyeIcon from "./images/icons/eye.svg?react";
import AlbumIcon from "./images/icons/multiple-images.svg?react";
import "./GifStats.scss";

interface IGifStats {
  gif: IGif;
  galleryImagesQty: number;
}

export const GifStats = memo(({ gif, galleryImagesQty }: IGifStats) => {
  const viewCount = nFormatter(gif.views);
  const isAlbum = gif.gallery;
  const viewLabel = `${viewCount} ${gif.type === 2 ? (isAlbum ? "album" : "image") : "gif"} views`;

  return (
    <div className="gifStats">
      <GifStatsItem icon={<EyeIcon />} label={viewLabel} />
      {isAlbum && <GifStatsItem icon={<AlbumIcon />} label={`${galleryImagesQty} images`} />}
    </div>
  );
});
